class LastCta extends HTMLElement {
  connectedCallback() {
    this.priceEl = this.querySelector("[data-lc-price]");
    this.prices = this.readData();

    this.scrollButton = this.querySelector("[data-lc-scroll]");
    if (this.scrollButton) {
      this.onClick = () => this.scrollToForm();
      this.scrollButton.addEventListener("click", this.onClick);
    }

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data ? event.data.variant : null;
        if (variant && variant.id) this.render(variant.id);
      });
    }

    this.onVariantEvent = (event) => {
      const detail = event ? event.detail : null;
      const id = detail && detail.variant ? detail.variant.id : detail ? detail.id : null;
      if (id) this.render(id);
    };
    document.addEventListener("variant:change", this.onVariantEvent);
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === "function") this.unsubscribe();
    document.removeEventListener("variant:change", this.onVariantEvent);
    if (this.scrollButton && this.onClick) {
      this.scrollButton.removeEventListener("click", this.onClick);
    }
  }

  readData() {
    const script = this.querySelector("[data-last-cta-data]");
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  render(variantId) {
    if (!this.priceEl) return;
    const price = this.prices[String(variantId)];
    if (price) this.priceEl.textContent = price;
  }

  scrollToForm() {
    const name = this.dataset.scrollTarget || "product-form";
    const selectors = {
      "product-form": ["product-form", ".product-form", "[id^='ProductSubmitButton']"],
      "product-top": [".product__info-wrapper", ".product", "main"],
      page_top: ["body"]
    };
    const list = selectors[name] || selectors["product-form"];

    let target = null;
    for (let i = 0; i < list.length; i++) {
      target = document.querySelector(list[i]);
      if (target) break;
    }
    if (!target) target = document.body;

    const rect = target.getBoundingClientRect();
    const top = rect.top + window.pageYOffset - 80;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: "smooth" });

    const focusable = target.querySelector("button, [href], input, select");
    if (focusable && typeof focusable.focus === "function") {
      window.setTimeout(() => focusable.focus({ preventScroll: true }), 500);
    }
  }
}

if (!customElements.get("last-cta")) {
  customElements.define("last-cta", LastCta);
}
